export const irrelevantIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19"><path fill="none" stroke="currentColor" stroke-width="1.3" d="M1 9.5a8 8 0 1 0 16 0 8 8 0 0 0-16 0zm2.343 5.657L14.657 3.843"/></svg>`,
    name: 'irrelevant' as const
};